  <div class="remove-item-dialog-container">
    <div>
      <h2>{{alternativePopup ? alternativePopup?.title : ('text_remove' | dbText)}}</h2>
      <p>{{alternativePopup ? alternativePopup?.description : ('text_pleaseConfirmYouWantToRemoveThisListItem' | dbText)}}</p>
      <div class="remove-item-actions-container">
        <a class="ds-btn"
           (click)="activeModal.close(false)">
          {{ 'text_cancel' | dbText }}
        </a>
        <a class="ds-btn-red"
           (click)="removeItem()">
          {{alternativePopup ? alternativePopup?.button : ('text_remove' | dbText)}}
        </a>
      </div>
    </div>
  </div>
